module.exports = __webpack_public_path__ + "static/media/1.ab42629d.jpg";